module.exports = __webpack_public_path__ + "static/media/24UHCHR6.c5750e22.jpg";